/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_GoalInputs */

const en_lg_companion_goal = /** @type {(inputs: Lg_Companion_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An optional Chrome extension package helps add your selected KerjaBareng meeting link to the Location field of an event draft. It does not sync a Calendar account.`)
};

const id_lg_companion_goal = /** @type {(inputs: Lg_Companion_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket ekstensi Chrome opsional membantu menambahkan tautan rapat KerjaBareng yang kamu pilih ke kolom lokasi draf acara. Ini bukan sinkronisasi akun Calendar.`)
};

/**
* | output |
* | --- |
* | "An optional Chrome extension package helps add your selected KerjaBareng meeting link to the Location field of an event draft. It does not sync a Calendar ac..." |
*
* @param {Lg_Companion_GoalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_goal = /** @type {((inputs?: Lg_Companion_GoalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_GoalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_goal(inputs)
	return en_lg_companion_goal(inputs)
});